import { useAuth0 } from "@auth0/auth0-react";
import styles from "./addExpenseCategory.module.css";
import { SketchPicker } from "react-color";
import { TextField } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { useEffect, useState } from "react";
import reactCSS from "reactcss";

const schema = yup.object().shape({
  title: yup.string().required("This field is Required"),
  color: yup.string().required("This field is Required"),
});

const AddExpenseCategory = ({ setAddModalOpen, setLoading, setSnackbarOpen, setSnackbarMsg, setAllData, editData }) => {
  const { getAccessTokenSilently } = useAuth0();
  const [selectedColor, setSelectedColor] = useState("#F17013");
  const [displayColorPicker, setDisplayColorPicker] = useState(false);

  const { handleSubmit, control, errors, setValue } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    defaultValues: {
      title: "",
      color: "",
    },
  });

  const bgstyles = reactCSS({
    default: {
      popover: { position: "absolute", zIndex: "2" },
      cover: {
        position: "fixed",
        top: "0px",
        right: "0px",
        bottom: "0px",
        left: "0px",
      },
    },
  });

  useEffect(() => {
    if (editData) {
      setValue("color", editData?.color);
      setValue("title", editData?.title);
      setSelectedColor(editData?.color);
    }
  }, [editData, setValue]);

  const onSubmit = async (data) => {
    setLoading(true);
    setAddModalOpen(false);

    data = { ...data };

    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    return axios.post(process.env.REACT_APP_PAYMENT_API_URL + "v1/expense-categories", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
    )
      .then((response) => {
        setSnackbarOpen(true);
        setSnackbarMsg("Expense category added successfully.");

        setLoading(false);

        setAllData((prev) => {
          return [response.data.data, ...prev];
        });
      })
      .catch((error) => {
        if (typeof error.response !== "undefined")
          toast.error(error.response.data.message);
        setLoading(false);
      });
  };

  const onUpdate = async (data) => {
    setLoading(true);
    setAddModalOpen(false);

    const token = await getAccessTokenSilently({
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
    });

    return axios
      .post(
        process.env.REACT_APP_PAYMENT_API_URL +
        "v1/expense-categories/" +
        editData?.id,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        setSnackbarOpen(true);
        setSnackbarMsg("Expense category updated successfully.");

        setLoading(false);

        setAllData((prev) => {
          return prev?.map((item) => {
            if (item.id === editData?.id) return response.data.data;
            return item;
          });
        });
      })
      .catch((error) => {
        if (typeof error.response !== "undefined")
          toast.error(error.response.data.message);
        setLoading(false);
      });
  };

  const handleChangeComplete = (color) => {
    setSelectedColor(color.hex);
    setValue("color", color.hex);
  };
  const handleClick = (value) => {
    setDisplayColorPicker((prv) => !prv);
  };

  const handleClose = () => {
    setDisplayColorPicker(false);
  };

  return (
    <div className={`${styles.AddprospectFirstStepForm}`}>
      <form onSubmit={handleSubmit(editData ? onUpdate : onSubmit)}>
        <div className={`${styles.AddPropertyHalfSecRow}`}>
          <div className={`${styles.HalfSecFull} FormGroup`}>
            <Controller
              name={`title`}
              control={control}
              render={(field) => (
                <TextField
                  onChange={(e) => field.onChange(e)}
                  id="outlined-basic"
                  label="Category Name*"
                  variant="outlined"
                  value={field.value}
                />
              )}
            />
            {errors.title && (
              <p className={`${styles.ErrorM}`}>{errors?.title?.message}</p>
            )}
          </div>

          <div className={`${styles.HalfSecFull} FormGroup`}>
            <Controller
              name={`color`}
              control={control}
              render={(field) => (
                <TextField
                  onChange={(e) => field.onChange(e)}
                  id="outlined-basic"
                  label="Color*"
                  variant="outlined"
                  value={field.value}
                />
              )}
            />
            <button
              className={`${styles.ColorSelectBU}`}
              type="button"
              onClick={() => handleClick(true)}
            >
              <div style={{ backgroundColor: selectedColor }}></div>
            </button>
            {displayColorPicker && (
              <div
                className={`${styles.ColorPickerWidget}`}
                style={bgstyles.popover}
              >
                <div
                  style={bgstyles.cover}
                  onClick={handleClose}
                  className="coverSubhankar"
                />
                <SketchPicker
                  onChangeComplete={handleChangeComplete}
                  color={setSelectedColor}
                />
              </div>
            )}
            {errors.color && (
              <p className={`${styles.ErrorM}`}>{errors?.color?.message}</p>
            )}
          </div>
        </div>

        <div className={`${styles.ButtonAction}`}>
          <button
            type="button"
            onClick={(e) => setAddModalOpen(false)}
            className="CancelPopupBU"
          >
            Cancel
          </button>
          <button type="submit" className="SubmitPopupBU">
            {editData ? "Update" : "Add"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddExpenseCategory;
